"use client"; // If this component is used client-side (optional, based on your setup)

import React from "react";
import { twMerge } from "tailwind-merge";

export const Header: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <h2 className={twMerge("text-primary text-center mb-4 ", className)}>
      {children}
    </h2>
  );
};

export const Subheader: React.FC<{
  children: React.ReactNode;
  className?: string;
  max?: number;
}> = ({ children, className, max }) => {
  return (
    <h3
      style={{
        maxWidth: max,
      }}
      className={twMerge(
        "text-secondary-main mx-auto max-w-[600px] text-center mb-16",
        className
      )}
    >
      {children}
    </h3>
  );
};

export const GroupHeader: React.FC<{
  header: string;
  subheader: string;
  max?: number;
}> = ({ header, subheader, max }) => {
  return (
    <>
      <Header>{header}</Header>
      <Subheader max={max}>{subheader}</Subheader>
    </>
  );
};
